import React from 'react';
import { observer } from 'mobx-react';
import { ReturnAddressEditTemplate } from 'themes/modules/return-address/pages';
import { ReturnAddressEditViewStore } from 'modules/return-address/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new ReturnAddressEditViewStore(rootStore, componentProps),
	'returnAddressEditViewStore'
)
@observer
class ReturnAddressEdit extends React.Component {
	render() {
		return <ReturnAddressEditTemplate {...this.props} />;
	}
}

export default ReturnAddressEdit;



// WEBPACK FOOTER //
// ./src/modules/return-address/pages/ReturnAddressEdit.jsx